const performanceDashboard = {
  title: 'Performance Dashboard',
  subTitle: 'Overview of key operational metrics',
  supplierSelector: {
    label: 'Choose Supplier:',
  },
  acceptDeclineTripsPie: {
    title: 'Accept / Decline Trips',
    pies: {
      accept: 'Accept',
      decline: 'Decline',
    },
  },
  assignmentTypePie: {
    title: 'Assignment Type',
    pies: {
      manual: 'Manual',
      automated: 'Automated',
    },
  },
  coverageCapacityChart: {
    title: 'Coverage Capacity',
    bars: {
      capacity: 'Capacity',
    },
  },
  fleetAcceptanceChart: {
    title: 'Fleet Acceptance',
    bars: {
      acceptance: 'Acceptance',
    },
  },
  noShowCancelationChart: {
    title: 'No-Show & Cancelation Rates',
    bars: {
      noShow: 'No-Show',
      cancelation: 'Cancelation',
    },
  },
  onTimePerformanceChart: {
    title: 'On-Time Performance',
    bars: {
      onTime: 'On-time',
    },
  },
  topFleetsByTripsChart: {
    title: 'Top 10 Fleets by Trips',
    bars: {
      trips: 'Trips',
    },
  },
  activeDriversByHourChart: {
    title: 'Top 10 Drivers by Trips',
    bars: {
      drivers: 'Drivers',
    },
  },
};

export default performanceDashboard;
